import "../styleSheets/footer.css";
import mtamLogo from "../images/eterniq_logo_footer.svg";
import LogoX from "../images/logo-x.svg";
import LogoInstagram from "../images/logo-instagram.svg";
import LogoWhatsapp from "../images/logo-whatsapp.svg";
import LogoFacebook from "../images/logo-facebook.svg";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { useTranslation } from "react-i18next";
import { getHomeRoute } from "../utilities/utilities";
import { useNavigationGuard } from "../contexts/NavigationGuardContext";
import React from "react";
import { trackEvent } from "../utilities/analytics";

function Footer() {
  const navigate = useNavigate();
  const { requestNavigation } = useNavigationGuard();
  const { isAuthenticated, isUserDataLoading, isUserActive } = useUser();
  const { t } = useTranslation("common");
  const canAccessProtectedApp =
    isAuthenticated && !isUserDataLoading && isUserActive !== false;

  const guardedGo = (to: string, eventName?: string) => {
    if (eventName) {
      trackEvent(eventName);
    }
    requestNavigation(() => navigate(to));
  };

  return (
    <footer
      className={`footer ${canAccessProtectedApp ? "footer-color-auth" : "footer-color-non-auth"}`}
    >
      <div className="container-footer">
        <div className="brand-info">
          <div className="logo-landscape" id="logoLandscapeContainer">
            <button
              type="button"
              className="footer-logo-btn"
              aria-label={t("header.logoAlt")}
              onClick={() => guardedGo(getHomeRoute(canAccessProtectedApp))}
            >
              <img src={mtamLogo} alt={t("header.logoAlt")} />
            </button>
          </div>

          <div className="divider" />

          <div className="footer-text">{t("footer.text")}</div>
        </div>

        <div className="footer-links">
          <button
            type="button"
            className="navigation-link"
            onClick={() => guardedGo("/Plans", "pricing_cta_clicked")}
          >
            {t("header.menu.pricing")}
          </button>

          <button
            type="button"
            className="navigation-link"
            onClick={() => guardedGo("/AboutFull")}
          >
            {t("footer.menu.aboutUs")}
          </button>

          <button
            type="button"
            className="navigation-link"
            onClick={() => guardedGo("/ContactUs", "contact_cta_clicked")}
          >
            {t("header.menu.contact")}
          </button>

          <button
            type="button"
            className="navigation-link"
            onClick={() => guardedGo("/FAQs")}
          >
            {t("header.menu.faqs")}
          </button>

          <button
            type="button"
            className="navigation-link"
            onClick={() => guardedGo("/TermsOfService")}
          >
            {t("footer.menu.terms")}
          </button>

          <button
            type="button"
            className="navigation-link"
            onClick={() => guardedGo("/PrivacyPolicy")}
          >
            {t("footer.menu.privPolicy")}
          </button>
        </div>

        <div className="footer-social-links">
          <a
            href="https://www.facebook.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <img
              src={LogoFacebook}
              className="social-media-icon"
              alt="Facebook Icon"
            />
          </a>

          <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <img
              src={LogoInstagram}
              className="social-media-icon"
              alt="Instagram Icon"
            />
          </a>

          <a
            href="https://wa.me/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <img
              src={LogoWhatsapp}
              className="social-media-icon"
              alt="WhatsApp Icon"
            />
          </a>

          <a
            href="https://x.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X"
          >
            <img src={LogoX} className="social-media-icon" alt="X Icon" />
          </a>
        </div>
      </div>

      <div className="copyright">
        © Copyright Eterniq {new Date().getFullYear()}. {t("footer.allRights")}
      </div>
    </footer>
  );
}

export default Footer;
